(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-gr-gallery]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const cards = [...root.querySelectorAll('.gr-media-card')];
      const dialog = root.querySelector('dialog'), stage = root.querySelector('[data-gr-stage]');
      let active = 0, opener;
      const visible = () => cards.filter(card => !card.hidden);
      const render = () => {
        const list = visible(), card = list[active], link = card.querySelector('[data-gr-open]');
        const isVideo = card.dataset.grType === 'video';
        const media = document.createElement(isVideo ? 'video' : 'img');
        media.src = link.href;
        if (isVideo) { media.controls = true; media.playsInline = true; media.preload = 'metadata'; media.poster = link.dataset.grPoster; }
        else media.alt = link.dataset.grCaption;
        stage.replaceChildren(media);
        root.querySelector('[data-gr-title]').textContent = link.dataset.grCaption;
        root.querySelector('[data-gr-position]').textContent = `${active + 1} / ${list.length}`;
      };
      root.querySelectorAll('[data-gr-filter]').forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.grFilter;
        root.querySelectorAll('[data-gr-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        cards.forEach(card => { card.hidden = filter !== 'all' && card.dataset.grCategory !== filter && card.dataset.grType !== filter; });
        root.querySelector('[data-gr-count]').textContent = visible().length;
      }));
      root.querySelectorAll('[data-gr-open]').forEach(link => link.addEventListener('click', event => {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault(); opener = link; active = visible().indexOf(link.closest('.gr-media-card')); render();
        dialog.showModal(); document.body.classList.add('gr-viewer-open');
      }));
      const move = delta => { active = (active + delta + visible().length) % visible().length; render(); };
      root.querySelector('[data-gr-prev]').addEventListener('click', () => move(-1));
      root.querySelector('[data-gr-next]').addEventListener('click', () => move(1));
      root.querySelector('[data-gr-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { stage.replaceChildren(); document.body.classList.remove('gr-viewer-open'); opener?.focus(); });
      dialog.addEventListener('click', e => { if(e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close(); } });
      dialog.addEventListener('keydown', e => { if (e.target.tagName === 'VIDEO') return; if (e.key === 'ArrowLeft') move(-1); if (e.key === 'ArrowRight') move(1); });
    });
    scope.querySelectorAll('[data-gr-film]').forEach(link => {
      if(link.dataset.initialized) return; link.dataset.initialized='true';
      link.addEventListener('click', e => { e.preventDefault(); const frame=document.createElement('iframe'); frame.src=`https://www.youtube-nocookie.com/embed/${encodeURIComponent(link.dataset.grFilm)}?autoplay=1`; frame.title='Global Grillz film'; frame.allow='autoplay; encrypted-media; fullscreen'; frame.allowFullscreen=true; link.replaceWith(frame); });
    });
  };
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
